module.exports = __webpack_public_path__ + "img/33@2x.90ae0f38.png";